import { cn } from '@workspace/ui/lib';
import type * as React from 'react';

function Alert({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(
        'border-grey-500 text-primary relative flex w-full items-center gap-2 rounded-[20px] border bg-transparent p-4 align-middle dark:text-neutral-100',
        className
      )}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="alert-title" className={cn('font-medium', className)} {...props} />;
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'text-grey-900 items-start! justify-center text-xs leading-5 font-normal md:text-sm dark:text-neutral-100',
        className
      )}
      {...props}
    />
  );
}

export { Alert, AlertDescription, AlertTitle };
